import { t } from '@core/i18n';
import { Option } from '@shared/components/select-new/Select';
import { ConfigAgencyConstants } from '@shared/models/config';

export interface OptionsGroup<TValues extends string = string> {
  label: string;
  keys: TValues[];
}

export type GroupOptions<TKeys extends string = string, TValues extends string = string> = Record<
  TKeys,
  OptionsGroup<TValues>
>;

export const tenureOptions = [
  { id: 'to_let', label: t('to_let') },
  { id: 'for_sale', label: t('for_sale') },
];

export const getCountryOptions = (constants: ConfigAgencyConstants): Option<string>[] =>
  Object.keys(constants.countryOptions || []).map((label) => ({
    id: constants.countryOptions[label] || '',
    label: label,
  }));

export const notifyRadioOptions = [
  { id: '1', label: t('notify_members') },
  { id: '0', label: t('dont_notify') },
];
